/* global $ */

const $window = $(window);
const $mediaRow: any = $('.media-row.is-slider .u-slider');

let lastBreakpoint;

function getIcon(name) {
  return `<svg class="icon icon-${name}"><use xlink:href="#icon-${name}"></use></svg>`;
}

function getButton(text, className, icon) {
  return `
    <button type="button" class="${className}">
      <span class="sr-only">${text}</span>
      ${getIcon(icon)}
    </button>
  `;
}

const mediaRowInst = {
  initialize() {
    if (!$mediaRow.length) {
      return;
    }

    this.createListeners();
    this.calcDimensions();
  },

  createListeners() {
    $window.on('resize', () => {
      this.calcDimensions();
    });
  },

  calcDimensions() {
    const newBreakpoint = $window.width() < 768 ? 'sm' : 'lg';

    if (newBreakpoint !== lastBreakpoint) {
      lastBreakpoint = newBreakpoint;
      this.create();
    }
  },

  create() {
    $mediaRow.slick({
      slidesToShow: 3,
      arrows: true,
      dots: true,
      adaptiveHeight: true,
      prevArrow: getButton('Vorige', 'slider__arrow slick-prev', 'arrow-left'),
      nextArrow: getButton('Volgende', 'slider__arrow slick-next', 'arrow-right'),
      responsive: [
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 1,
          },
        }, {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
          },
        },
      ],
    });
  },
};

export default mediaRowInst;
